"use strict";

exports.__esModule = true;
var _EnhancedContextLoader = require("./EnhancedContextLoader");
Object.keys(_EnhancedContextLoader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EnhancedContextLoader[key]) return;
  exports[key] = _EnhancedContextLoader[key];
});